import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import ReactTooltip from 'react-tooltip'
import moment from 'moment'
import config from '../../config'
import convert from '../../helpers/convert'
import format from '../../helpers/format'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  TspDisclaimer,
  FundTargetDateLinks
} from '../../components'
import Styles from './FundName.css'

@CSSModules(Styles, {allowMultiple:true})
export default class FundName extends Component {
  static propTypes = {
    shareClass: PropTypes.object.isRequired,
    pathname: PropTypes.string.isRequired
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props){
    super(props)
  }

  render() {
    const sriIcon = require( '../../../static/images/sri.png' )
    const ussifLogo = require( '../../../static/images/ussif-icon.png' )
    const shareClass = this.props.shareClass
    const hasSRIBadge = convert.boolean(shareClass.socially_responsible_fund)
    const hasUssifBadge = convert.float(shareClass.ussif) === 1.5
    const isTargetDate = shareClass.is_target_date

    // 20241018
    // hack for WFF-APP
    let famUrl = config.routes.families + '?q=' +
      encodeURIComponent(shareClass.fund_family_name)
    if (config.app.title === 'Weapon Free Funds') {
      famUrl = config.routes.fundManager + '/' + encodeURIComponent(shareClass.fund_family_name)
    }

    const legalType = {
      'ETF': 'Exchange-traded fund',
      'Open': 'Open-end mutual fund',
      // 'TSP': 'TSP fund',
      'VA': 'Variable annuity',
      'Other': 'Other',
    }[shareClass.legal_type] || 'ERR'

    //
    return (
      <ContainerDivs>
        <header styleName='fund-name-wrap'>
          <div>
            <h1 styleName='legalname'>
              { shareClass.fund_legal_name }
            </h1>
            <div styleName='name-label-value'>
              <div styleName='name-label'>Shareclass</div>
              <div styleName='name-value'>
                { shareClass.name }
                { shareClass.ticker ? ` (${shareClass.ticker})` : null }
              </div>
            </div>
            <div styleName='name-label-value'>
              <div styleName='name-label'>
                Type
              </div>
              <div styleName='name-value'>
                { legalType }
              </div>
            </div>
            <div styleName='name-label-value'>
              <div styleName='name-label'>
                Manager
              </div>
              <div styleName='name-value'>
                <Link
                  to={famUrl}
                  title={shareClass.fund_family_name}
                >
                  <span styleName='fund-manager-name'>
                    {shareClass.fund_family_name}
                  </span>
                </Link>
              </div>
            </div>

            <div styleName='name-label-value'>
              <div styleName='name-label'>
                Filing
              </div>
              <div styleName='name-value'>
                <Link
                  to={'https://www.sec.gov/Archives/edgar/data/' + shareClass.morningstar_url + '.txt'}
                  title='Filing'
                >
                  <span styleName='fund-manager-name'>
                    NPORT filing { moment(shareClass.date.slice(0,10)).format('D MMM YYYY')}
                  </span>
                </Link>
              </div>
            </div>

            {
              isTargetDate ?
                <div>
                  <div styleName='name-label-value'>
                    <div styleName='name-label'>
                      Target date
                    </div>
                    <div styleName='name-value'>
                      { shareClass.strategy_name }
                    </div>
                  </div>
                  <FundTargetDateLinks strategyName={shareClass.strategy_name} />
                </div> :
                null
            }

          </div>
          { hasSRIBadge || hasUssifBadge ?
            <div styleName='sri-icons-wrap'>
              { hasSRIBadge ?
                  <img
                    styleName='sri'
                    src={sriIcon}
                    alt='Sustainability mandate'
                    data-multiline
                    data-effect='solid'
                    data-tip={
                      '<div style=\'max-width:250px;\'>Reports a ' +
                        'Sustainability Mandate to Morningstar. ' +
                        'Sustainable funds consider issues like the ' +
                        'environment and human rights.</div>'
                    }
                    data-html
                    data-place='bottom'
                    data-for='fundname-sri-tooltip'
                  /> :
                  null
              }
              <ReactTooltip id='fundname-sri-tooltip'/>
              { hasUssifBadge ?
                  <img
                    styleName='ussif'
                    src={ussifLogo}
                    alt='Member of US-SIF'
                    data-multiline
                    data-effect='solid'
                    data-tip={
                      '<div style=\'max-width:250px;\'>Member of The Forum ' +
                        'for Sustainable and Responsible Investment.</div>'
                    }
                    data-html
                    data-place='bottom'
                    data-for='fundname-ussif-tooltip'
                  /> :
                  null
              }
              <ReactTooltip id='fundname-ussif-tooltip'/>
            </div> :
            null
          }
        </header>

        { shareClass.fund_family_name === 'Thrift Savings Plan' ?
            <TspDisclaimer shareclass={shareClass}/> :
            null
        }
      </ContainerDivs>
    )
  }
}
